import { createFileRoute } from '@tanstack/react-router';
import { ApplyPage } from '@/features/travel-credit-card/apply/apply-page';
import { resolveDevice } from '@/features/travel-credit-card/constants/device';
import { APPLY_CONTENT } from '@/features/travel-credit-card/content/content';
import {
	ForceLightScheme,
	forceLightSchemeScript,
} from '@/features/travel-credit-card/layout/force-light-scheme';
import { seo } from '@/utils/seo';

// /travel-credit-card/apply — CBCC application form. The `_` suffix in the
// filename un-nests this from the /travel-credit-card route (which renders the
// landing page directly, with no Outlet). Per-user form page: stays SPA
// (app default) and inherits the root noindex.
export const Route = createFileRoute('/travel-credit-card_/apply')({
	head: () => ({
		meta: [
			...seo({
				title: `Apply — ${APPLY_CONTENT.form.title}`,
				description: APPLY_CONTENT.form.title,
			}),
		],
		// Pin color-scheme: light for this route (see force-light-scheme.tsx).
		scripts: [{ children: forceLightSchemeScript }],
	}),
	// Resolve the web/mweb variant from the User-Agent so ApplyPage renders the
	// right chrome (mweb = full-bleed white form). Isomorphic — request UA on
	// the server, navigator on the client; SPA route, so this runs client-side,
	// but resolveDevice handles both. See constants/device.ts.
	loader: () => ({ device: resolveDevice() }),
	component: ApplyRoute,
});

function ApplyRoute() {
	const { device } = Route.useLoaderData();
	return (
		<>
			<ForceLightScheme />
			<ApplyPage device={device} />
		</>
	);
}
